import { useEffect, useState } from 'react';
import { invalidateSharedQueries } from '@utils/sharedQuery';

const listeners = new Set<(propertyId: string) => void>();

/** Runs finish after the launch mutation; invalidate the results at completion too. */
export function propertyAnalysisUpdated(propertyId: string) {
  invalidateSharedQueries();
  listeners.forEach((listener) => listener(propertyId));
}

export function usePropertyAnalysisRevision(propertyId: string) {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const listener = (id: string) => {
      if (id === propertyId) setRevision((value) => value + 1);
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, [propertyId]);
  return revision;
}
